import {kioskModeType} from '../config/const';
import { isMainBoard } from '../selectors/configSelectors';
import store from './../store';

export const rootPageUri = process.env.PUBLIC_URL + '/';
// export const categoryUri = [process.env.PUBLIC_URL, "/category/:categoryName"].join('');
export const cartUri = [process.env.PUBLIC_URL, "/cart"].join('');
export const checkOutUri = [process.env.PUBLIC_URL, "/checkout"].join('');
export const achPaymentUri = [process.env.PUBLIC_URL, "/ach"].join('');
export const menuUri = [process.env.PUBLIC_URL, "/menu"].join('');
export const filterUri = [process.env.PUBLIC_URL, "/filter"].join('');
export const filterOldUri = [process.env.PUBLIC_URL, "/1_filter"].join('');
export const suggestionsUri = [process.env.PUBLIC_URL, "/suggestions"].join('');
export const membershipUri = process.env.PUBLIC_URL + "/membership";
export const ordersUri = process.env.PUBLIC_URL + "/orders";
export const searchUri = `${process.env.PUBLIC_URL}/search`;
export const searchReadOnlyUri = `${process.env.PUBLIC_URL}/readonly/search`;
export const searchOldUri = process.env.PUBLIC_URL + "/1_search";
export const addressesUri = process.env.PUBLIC_URL + "/addresses";
export const helpUri = process.env.PUBLIC_URL + "/help";
export const notificationUri = process.env.PUBLIC_URL + "/notification";
export const myaccountUri = process.env.PUBLIC_URL + "/account";
export const updateDocsPageUri = process.env.PUBLIC_URL + "/account/update";
export const updateDocsUri = process.env.PUBLIC_URL + "/account/update/:type";
export const ordersHistoryUri = process.env.PUBLIC_URL + "/orders/:orderId";
export const uploadRecUri = process.env.PUBLIC_URL + '/account/update/rec';
export const uploadDlUri = process.env.PUBLIC_URL + '/account/update/dl';
export const uploadMiscUri = process.env.PUBLIC_URL + '/account/update/misc';
export const maintenanceUri = process.env.PUBLIC_URL + '/maintenance';
export const resetPasswordUri = process.env.PUBLIC_URL + "/reset/:code";
export const thankYouUri = process.env.PUBLIC_URL + '/thankyou';
export const failureUri = process.env.PUBLIC_URL + '/failure';

export const getSearchUri = () => {
  if (isMainBoard(store.getState())) {
    return searchReadOnlyUri;
  }

  return searchUri;
};

// Kiosk implementation
export const onlineMenuPageUri = `${process.env.PUBLIC_URL}`;
export const kioskRootPageUri = `${process.env.PUBLIC_URL}/${kioskModeType.PAYMENT_KIOSK}`;
export const dposRootPageUri = `${process.env.PUBLIC_URL}/${kioskModeType.DPOS}`;
export const mainBoardModePageUri = `${process.env.PUBLIC_URL}/${kioskModeType.MAIN_BOARD}`;
export const selfServiceKioskModePageUri = `${process.env.PUBLIC_URL}/${kioskModeType.SELF_SERVICE_KIOSK}`;

export const closedUrls = [
  '/checkout',
  '/account'
];



// WEBPACK FOOTER //
// ./src/config/uri.js